export default __webpack_public_path__ + "static/slider3-206dcf7514c71395830f9dc4a33ed183.jpg";